import { apiRemote, IListSubmissionTcc, IUserRoundStatus } from "@/api";
import { createContext, ReactNode, useCallback, useContext, useEffect, useState } from "react";

interface UserRoundContextType {
    userCompetition: IUserRoundStatus["competition"] | null;
    setUserCompetition: (newItem: IUserRoundStatus["competition"]) => void;
    userRound: IUserRoundStatus["rounds"];
    setUserRound: (newItem: IUserRoundStatus["rounds"]) => void;
    userRoundParts: IUserRoundStatus["round_parts"];
    setUserRoundParts: (newItem: IUserRoundStatus["round_parts"]) => void;
    loading: boolean;
    setAiUsage: (newAI: IUserRoundStatus["ai_usage"]) => void;
    loadUserRound: () => Promise<void>;
    loadUserRound1: () => Promise<void>;
    aiUsage: IUserRoundStatus["ai_usage"] | null;
    loadTCCSubmission: (current_page: number, pageSize: number) => Promise<void>;
    loadTCCSubmission1: (current_page: number, pageSize: number) => Promise<void>;
    loadingSubmission: boolean;
    setSubmissions: (newItem: IListSubmissionTcc["data"]["data"]) => void;
    submissions: IListSubmissionTcc["data"]["data"] | [];
    currentPageSubmission: any;
    setCurrentPageSubmission: (page: number) => void;
    pageSizeSubmission: number;
    setPageSizeSubmission: (size: number) => void;
    totalCountSubmission: number;
    setTotalCountSubmission: (size: number) => void;
    setTopRank: (newItem: IListSubmissionTcc["data"]["top_users"]) => void;
    topRank: IListSubmissionTcc["data"]["top_users"] | [];
  }

  // Tạo context với giá trị mặc định
const UserRoundContext = createContext<UserRoundContextType | undefined>(undefined);

// Provider để bọc toàn bộ ứng dụng
export const ThoughtCoCreateProvider = ({ children }: { children: ReactNode }) => {
  const [userCompetition, setUserCompetition] = useState<IUserRoundStatus["competition"] | null>(null);
  const [userRound, setUserRound] = useState<IUserRoundStatus["rounds"]>([]);
  const [userRoundParts, setUserRoundParts] = useState<IUserRoundStatus["round_parts"]>([]);
  const [aiUsage, setAiUsage] = useState<IUserRoundStatus["ai_usage"] | null>( null);
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingSubmission, setLoadingSubmission] = useState<boolean>(false);
  const [submissions, setSubmissions] = useState<IListSubmissionTcc["data"]["data"]>([]);
  const [topRank, setTopRank] = useState<IListSubmissionTcc["data"]["top_users"]>([]);
  const [currentPageSubmission, setCurrentPageSubmission] = useState(1);
  const [pageSizeSubmission, setPageSizeSubmission] = useState(9);
  const [totalCountSubmission, setTotalCountSubmission] = useState(0);

  const loadUserRound = useCallback(async () => {
    setLoading(true);
    try {
      const response = await apiRemote.getUserRoundStatus();
      if (response?.competition) {
        setUserCompetition(response.competition);
      }
      if (response?.rounds) {
        setUserRound(response.rounds);
      }
      if (response?.round_parts) {
        setUserRoundParts(response.round_parts);
      }
      if (response?.ai_usage) {
        setAiUsage(response.ai_usage);
      }
    } catch (error) {
      console.error("Lỗi khi tải dữ liệu:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const loadUserRound1 = useCallback(async () => {
    try {
      const response = await apiRemote.getUserRoundStatus();
      if (response?.competition) {
        setUserCompetition(response.competition);
      }
      if (response?.rounds) {
        setUserRound(response.rounds);
      }
      if (response?.round_parts) {
        setUserRoundParts(response.round_parts);
      }
      if (response?.ai_usage) {
        setAiUsage(response.ai_usage);
      }
    } catch (error) {
      console.error("Lỗi khi tải dữ liệu:", error);
    } finally {
      // setLoading(false);
    }
  }, []);

  const loadTCCSubmission = useCallback(async (current_page: number, pageSize: number) => {
    setLoadingSubmission(true);
    try {
      const response = await apiRemote.getListSubmissionTcc(current_page, pageSize);
      if (response?.data) {
        setSubmissions(response.data.data);
        setTopRank(response.data.top_users);
        setTotalCountSubmission(response.data.total);
      }
      
    } catch (error) {
      console.error("Lỗi khi tải dữ liệu:", error);
    } finally {
      setLoadingSubmission(false);
    }
  }, []);

  const loadTCCSubmission1 = useCallback(async (current_page: number, pageSize: number) => {
    // setLoadingSubmission(true);
    try {
      const response = await apiRemote.getListSubmissionTcc(current_page, pageSize);
      if (response?.data) {
        setSubmissions(response.data.data);
        setTopRank(response.data.top_users);
        setTotalCountSubmission(response.data.total);
        return response;
      }
      return null;
    } catch (error) {
      console.error("Lỗi khi tải dữ liệu:", error);
      throw error;
    }
  }, []);

  return (
    <UserRoundContext.Provider value={{ userCompetition, setUserCompetition, userRound, setUserRound, userRoundParts, setUserRoundParts, loading, setAiUsage, loadUserRound, aiUsage, loadUserRound1, loadTCCSubmission, loadingSubmission, setSubmissions, submissions, currentPageSubmission, setCurrentPageSubmission, pageSizeSubmission, setPageSizeSubmission, totalCountSubmission, setTotalCountSubmission, loadTCCSubmission1, topRank, setTopRank }}>
      {children}
    </UserRoundContext.Provider>
  );
};

// Hook để sử dụng context
export const useThoughtCoCreate = (): UserRoundContextType => {
  const context = useContext(UserRoundContext);
  if (!context) {
    throw new Error("useUserRound phải được sử dụng trong UserRoundProvider");
  }
  return context;
};